import BaseAtomFactory from "../../utils/BaseAtomFactory";
import announcementsRepository from '../repositories-repo/announcements';

const operations = {
  __name: "announcements",
  read: async () => {
    return [await announcementsRepository.read('BCOC')];
  },
};
const announcementsAtom = new BaseAtomFactory(operations, null, {
  rereadOnMount: false
});
export default announcementsAtom;
